import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { environment } from '@environments/environment';
import { ApiResponse } from '@app/_models';
import { retry, catchError } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { AlertService } from '@app/_services';
import { MaintenanceEvent } from './maintenance-event';
import { SharedService } from './../_shared/shared.service';

@Injectable({ providedIn: 'root' })
export class MaintenanceEventService {

	statuses: any = [
		{ value: '0', name: 'Planned' },
		{ value: '1', name: 'In-process' },
		{ value: '2', name: 'Complete' }
	];

	resolutions: any = [
		{ value: '0', name: 'Notify Only' },
		{ value: '1', name: 'Refund' },
		{ value: '2', name: 'Relocate' },
		{ value: '3', name: 'Other' },
	];

	visibilities: any = [
		{ value: '0', name: 'Internal' },
		{ value: '1', name: 'Existing Guests' },
		{ value: '2', name: 'Public' },
	];

	time = [
		{ value: '12:00 AM', name: '12:00 AM' },
		{ value: '12:15 AM', name: '12:15 AM' },
		{ value: '12:30 AM', name: '12:30 AM' },
		{ value: '12:45 AM', name: '12:45 AM' },
		{ value: '1:00 AM', name: '1:00 AM' },
		{ value: '1:15 AM', name: '1:15 AM' },
		{ value: '1:30 AM', name: '1:30 AM' },
		{ value: '1:45 AM', name: '1:45 AM' },
		{ value: '2:00 AM', name: '2:00 AM' },
		{ value: '2:15 AM', name: '2:15 AM' },
		{ value: '2:30 AM', name: '2:30 AM' },
		{ value: '2:45 AM', name: '2:45 AM' },
		{ value: '3:00 AM', name: '3:00 AM' },
		{ value: '3:15 AM', name: '3:15 AM' },
		{ value: '3:30 AM', name: '3:30 AM' },
		{ value: '3:45 AM', name: '3:45 AM' },
		{ value: '4:00 AM', name: '4:00 AM' },
		{ value: '4:15 AM', name: '4:15 AM' },
		{ value: '4:30 AM', name: '4:30 AM' },
		{ value: '4:45 AM', name: '4:45 AM' },
		{ value: '5:00 AM', name: '5:00 AM' },
		{ value: '5:15 AM', name: '5:15 AM' },
		{ value: '5:30 AM', name: '5:30 AM' },
		{ value: '5:45 AM', name: '5:45 AM' },
		{ value: '6:00 AM', name: '6:00 AM' },
		{ value: '6:15 AM', name: '6:15 AM' },
		{ value: '6:30 AM', name: '6:30 AM' },
		{ value: '6:45 AM', name: '6:45 AM' },
		{ value: '7:00 AM', name: '7:00 AM' },
		{ value: '7:15 AM', name: '7:15 AM' },
		{ value: '7:30 AM', name: '7:30 AM' },
		{ value: '7:45 AM', name: '7:45 AM' },
		{ value: '8:00 AM', name: '8:00 AM' },
		{ value: '8:15 AM', name: '8:15 AM' },
		{ value: '8:30 AM', name: '8:30 AM' },
		{ value: '8:45 AM', name: '8:45 AM' },
		{ value: '9:00 AM', name: '9:00 AM' },
		{ value: '9:15 AM', name: '9:15 AM' },
		{ value: '9:30 AM', name: '9:30 AM' },
		{ value: '9:45 AM', name: '9:45 AM' },
		{ value: '10:00 AM', name: '10:00 AM' },
		{ value: '10:15 AM', name: '10:15 AM' },
		{ value: '10:30 AM', name: '10:30 AM' },
		{ value: '10:45 AM', name: '10:45 AM' },
		{ value: '11:00 AM', name: '11:00 AM' },
		{ value: '11:15 AM', name: '11:15 AM' },
		{ value: '11:30 AM', name: '11:30 AM' },
		{ value: '11:45 AM', name: '11:45 AM' },
		{ value: '', name: '' },
		{ value: '12:00 PM', name: '12:00 PM' },
		{ value: '12:15 PM', name: '12:15 PM' },
		{ value: '12:30 PM', name: '12:30 PM' },
		{ value: '12:45 PM', name: '12:45 PM' },
		{ value: '1:00 PM', name: '1:00 PM' },
		{ value: '1:15 PM', name: '1:15 PM' },
		{ value: '1:30 PM', name: '1:30 PM' },
		{ value: '1:45 PM', name: '1:45 PM' },
		{ value: '2:00 PM', name: '2:00 PM' },
		{ value: '2:15 PM', name: '2:15 PM' },
		{ value: '2:30 PM', name: '2:30 PM' },
		{ value: '2:45 PM', name: '2:45 PM' },
		{ value: '3:00 PM', name: '3:00 PM' },
		{ value: '3:15 PM', name: '3:15 PM' },
		{ value: '3:30 PM', name: '3:30 PM' },
		{ value: '3:45 PM', name: '3:45 PM' },
		{ value: '4:00 PM', name: '4:00 PM' },
		{ value: '4:15 PM', name: '4:15 PM' },
		{ value: '4:30 PM', name: '4:30 PM' },
		{ value: '4:45 PM', name: '4:45 PM' },
		{ value: '5:00 PM', name: '5:00 PM' },
		{ value: '5:15 PM', name: '5:15 PM' },
		{ value: '5:30 PM', name: '5:30 PM' },
		{ value: '5:45 PM', name: '5:45 PM' },
		{ value: '6:00 PM', name: '6:00 PM' },
		{ value: '6:15 PM', name: '6:15 PM' },
		{ value: '6:30 PM', name: '6:30 PM' },
		{ value: '6:45 PM', name: '6:45 PM' },
		{ value: '7:00 PM', name: '7:00 PM' },
		{ value: '7:15 PM', name: '7:15 PM' },
		{ value: '7:30 PM', name: '7:30 PM' },
		{ value: '7:45 PM', name: '7:45 PM' },
		{ value: '8:00 PM', name: '8:00 PM' },
		{ value: '8:15 PM', name: '8:15 PM' },
		{ value: '8:30 PM', name: '8:30 PM' },
		{ value: '8:45 PM', name: '8:45 PM' },
		{ value: '9:00 PM', name: '9:00 PM' },
		{ value: '9:15 PM', name: '9:15 PM' },
		{ value: '9:30 PM', name: '9:30 PM' },
		{ value: '9:45 PM', name: '9:45 PM' },
		{ value: '10:00 PM', name: '10:00 PM' },
		{ value: '10:15 PM', name: '10:15 PM' },
		{ value: '10:30 PM', name: '10:30 PM' },
		{ value: '10:45 PM', name: '10:45 PM' },
		{ value: '11:00 PM', name: '11:00 PM' },
		{ value: '11:15 PM', name: '11:15 PM' },
		{ value: '11:30 PM', name: '11:30 PM' },
		{ value: '11:45 PM', name: '11:45 PM' }
	];

	constructor
		(
			private http: HttpClient,
			private alertService: AlertService,
			private sharedService: SharedService
		) { }

	urlEndpoint = 'maintenanceEvents';

	add(maintenanceEvent: MaintenanceEvent): Observable<ApiResponse> {
		console.log('posting... ' + JSON.stringify(maintenanceEvent));
		return this.http.post<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}`, maintenanceEvent);
	}

	update(maintenanceEvent: MaintenanceEvent): Observable<ApiResponse> {
		return this.http.patch<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}`, maintenanceEvent);
	}

	delete(developmentId: number): Observable<ApiResponse> {
		return this.http.delete<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/${developmentId}`);
	}

	findAll(): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}`).pipe(retry({ count: 2, delay: 1500 }));
	}

	findByFilter(page: any, size: any, sortBy: any, sortOrder: any, multiSortMeta, globalFilter: any, filters: any): Observable<ApiResponse> {
		let params = this.sharedService.prepareParamsFromPrimeNgDataTable(page, size, sortBy, sortOrder, multiSortMeta, globalFilter, filters);
		console.log('posting... ' + JSON.stringify(filters));
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}`, { params: params }).pipe(retry({ count: 2, delay: 1500 }));

	}

	findById(id: number): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/${id}`).pipe(retry({ count: 2, delay: 1500 }));
	}

	audit(id: number): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/${id}/audit`).pipe(retry({ count: 2, delay: 1500 }));
	}

	sendEmail(emailHtml: any, obj: any): Observable<ApiResponse> {
	  const req = {
	    obj,
		emailHtml
    };
    return this.http.post<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/send-email`, req);
  }


	prepareParamsFromPrimeNgDataTable(page: any, size: any, sortBy: any, sortOrder: any, multiSortMeta, globalFilter: any, filters: any) {
		try {
			console.log(
				'  |  page:' + page
				+ '  |  size:' + size
				+ '  |  sortBy:' + sortBy
				+ '  |  sortOrder:' + sortOrder
				+ '  |  multiSortMeta:' + JSON.stringify(multiSortMeta)
				+ '  |  globalFilter:' + globalFilter
				+ '  |  filters:' + JSON.stringify(filters)
			);

			let params = new HttpParams();

			if (!isNaN(page)) { params = params.append('page', page); }
			if (!isNaN(size)) { params = params.append('size', size); }
			if (sortBy) { params = params.append('sort', sortBy + ',' + (sortOrder === 1 ? 'asc' : 'desc')); }
			if (multiSortMeta) {
				// if sortMode="multiple" in primeng table then multiSortMeta is used for ALL sorting (even just one column.)
				// Otherwise, single sorting is used above.
				// event.multiSortMeta:[{"field":"lastName","order":1},{"field":"firstName","order":1}]
				for (let i = 0; i < multiSortMeta.length; i++) {
					let json = JSON.parse(JSON.stringify(multiSortMeta[i]));
					params = params.append('sort', json.field + ',' + (json.order === 1 ? 'asc' : 'desc'));
				}
			}
			// globalFilter works, but did not implemnt in Spring but not hard to write custom findAll and specify certain columns to look.
			if (globalFilter) { params = params.append('filter', globalFilter); }

			// multiselect or input or whatever... these work slick.
			if (filters) {
				// key:status val:{"value":["A"],"matchMode":"in"}
				for (let i = 0, keys = Object.keys(filters), ii = keys.length; i < ii; i++) {
					console.log('key:' + keys[i] + ' val:' + JSON.stringify(filters[keys[i]]));
					params = params.append(keys[i], filters[keys[i]].value);
				}
			}
			return params;
		} catch (error) {
			console.log('prepareParamsFromPrimeNgDataTable()' + error);
		}
	}
}
